import { render, staticRenderFns } from "./WebPartSlickerImage2Designer.vue?vue&type=template&id=87eaad34&scoped=true&"
import script from "./WebPartSlickerImage2Designer.vue?vue&type=script&lang=js&"
export * from "./WebPartSlickerImage2Designer.vue?vue&type=script&lang=js&"
import style0 from "./WebPartSlickerImage2Designer.vue?vue&type=style&index=0&id=87eaad34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eaad34",
  null
  
)

export default component.exports